export const WEBSITE_API_URL = 'https://typometry.io';
//# sourceMappingURL=constants.js.map